import { useIsAdmin } from "../api/auth.js";
import { useDefaultEngagement } from "../api/engagement-plan.js";
import { useTenants } from "../api/tenants.js";

import type { ProgrammeHubServices } from "@l30/web-programme/host";

/**
 * Hub-side implementation of the `ProgrammeHubServices` port (ADR-0101 Phase 5a).
 *
 * `@l30/web-programme` must not import `packages/web/src/**`, so every
 * cross-domain hook it needs (auth admin, tenants, default engagement) is
 * proxied through this factory and injected via `<ProgrammeHubProvider>`
 * (mounted in `_authenticated.tsx`). This is a plain object of hook
 * references — not a hook itself — so it can be constructed once per
 * render without violating rules-of-hooks.
 */
export function createProgrammeHubServices(): ProgrammeHubServices {
  return {
    useIsAdmin,
    useTenants,
    useDefaultEngagement,
  };
}
